import { UserKeys } from "./api-key";

export function isClientKeyGenerated(keys?: UserKeys): boolean {
  if (!keys) return false;
  return keys.clientApiKeyId != null && keys.clientApiKeyId.length > 0;
}
